import { useInstance, createRef } from 'intact-vue-next';
import { useDraggable as useBaseDraggable } from '../../hooks/useDraggable';
var VALUE_REG = /(?:(\d+(?:\.\d+)?)%)?([\+\-])?(\d+(?:\.\d+)?)?/;
var cache = {};
export function useDraggable(firstSize, lastSize) {
  var instance = useInstance();
  var elementRef = createRef();
  var firstRef = createRef();
  var lastRef = createRef();
  var min = 0;
  var max = 0;
  var targetRef;
  var targetSize;
  var baseX = 0;
  var baseY = 0;
  var originalWidth = 0;
  var originalHeight = 0;
  var _useBaseDraggable = useBaseDraggable({
      onStart: onStart,
      onMove: onMove,
      onEnd: onEnd
    }),
    start = _useBaseDraggable.start,
    dragging = _useBaseDraggable.dragging;
  function onStart(e) {
    // set mouse style
    setMouseStyle(true);
    calcMinMaxValue();
    if (lastSize.value === 'auto') {
      targetRef = firstRef;
      targetSize = firstSize;
    } else {
      targetRef = lastRef;
      targetSize = lastSize;
    }
    var targetEl = targetRef.value;
    originalWidth = restrainValue(targetEl.offsetWidth);
    originalHeight = restrainValue(targetEl.offsetHeight);
    baseX = e.clientX;
    baseY = e.clientY;
    instance.trigger('moveStart', e);
  }
  function onMove(e) {
    var changed;
    var originalSize;
    if (instance.get('mode') === 'horizontal') {
      originalSize = originalWidth;
      changed = e.clientX - baseX;
    } else {
      originalSize = originalHeight;
      changed = e.clientY - baseY;
    }
    if (targetRef === lastRef) {
      changed = -changed;
    }
    targetSize.set(restrainValue(originalSize + changed) + "px");
    instance.trigger('moving', e);
  }
  function onEnd(e) {
    // reset mouse style
    setMouseStyle();
    instance.trigger('moveEnd', e);
  }
  function calcMinMaxValue() {
    var _instance$get = instance.get(),
      _min = _instance$get.min,
      _max = _instance$get.max,
      mode = _instance$get.mode;
    var parsedMin = parseValue(_min);
    var parsedMax = parseValue(_max);
    if (parsedMin.percent || parsedMax.percent) {
      var totalSize = mode === 'horizontal' ? elementRef.value.offsetWidth : elementRef.value.offsetHeight;
      min = generateValue(parsedMin, totalSize);
      max = generateValue(parsedMax, totalSize);
    } else {
      min = _min;
      max = _max;
    }
  }
  function setMouseStyle(set) {
    if (set === void 0) {
      set = false;
    }
    document.body.style.cursor = set ? instance.get('mode') === 'vertical' ? 'row-resize' : 'col-resize' : '';
  }
  function restrainValue(value) {
    return Math.min(Math.max(value, min), max);
  }
  return {
    start: start,
    dragging: dragging,
    elementRef: elementRef,
    firstRef: firstRef,
    lastRef: lastRef
  };
}
function parseValue(v) {
  if (typeof v === 'undefined') return cache;
  if (typeof v === 'number') return {
    px: v
  };
  if (!cache[v]) {
    var matches = v.match(VALUE_REG) || [];
    cache[v] = {
      percent: matches[1],
      op: matches[2],
      px: matches[3]
    };
  }
  return cache[v];
}
function generateValue(_ref, totalSize) {
  var percent = _ref.percent,
    op = _ref.op,
    px = _ref.px;
  if (percent) {
    var value = totalSize * Number(percent) / 100;
    if (px) {
      px = Number(px);
      value = op === '-' ? value - px : value + px;
    }
    return value;
  }
  return Number(px);
}